<ng-container *ngIf="phoneNumber; else noPhoneNumber">
	<a type="button" class="link" target="_blank" [href]="query">
		{{ phoneNumber | mobileNumber }}
	</a>
</ng-container>
<ng-template #noPhoneNumber> N/A </ng-template>
